import React from "react";
// import { Link } from "react-router-dom";
import LogoAnthemWhite from "./img/LogoAnthemWhite";
import LogoIngenioWhite from "./img/LogoIngenioWhite";

function IEPCardIntro() {
	window.scrollTo(0, 0); // scroll to top of page

	return (
		<section className="card-iep-intro">
			<span className="logos">
				<LogoAnthemWhite />
				<LogoIngenioWhite />
			</span>
			<div className="content-row">
				<article className="content">
					<h2 className="title">Pharmacy benefits eligibility application</h2>
					<p className="para">
						IngenioRx is a startup within the Anthem group that deals with{" "}
						<a
							className="link-inline"
							href="https://www.ingenio-rx.com/managing-costs-with-clarity/"
							target="_blank"
							rel="noopener noreferrer"
						>
							Pharmacy Benefits Management
						</a>{" "}
						(PBM).
					</p>
					<p className="para">
						Ingenio needed a front-end delivered for an application that would
						manage the benefits eligibility for millions of its commercial and
						Medicare customers.
					</p>
					<p className="para">
						I was contracted to lead the product design for this enterprise
						application. I was the sole design resource in a distributed team of
						systems architects, product owners, and software developers.
					</p>
				</article>
				<blockquote className="pullquote">
					…UX/UI for managing eligibility, pharmacy costs, medication adherence,
					reporting, and analytics for millions of members and a hierarchy of
					groups and providers
				</blockquote>
			</div>
			<i className="icon-scroll-down"></i>
		</section>
	);
}

export default IEPCardIntro;
